import { render, staticRenderFns } from "./pubhouse.vue?vue&type=template&id=5a042543&scoped=true&"
import script from "./pubhouse.vue?vue&type=script&lang=js&"
export * from "./pubhouse.vue?vue&type=script&lang=js&"
import style0 from "./pubhouse.vue?vue&type=style&index=0&id=5a042543&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a042543",
  null
  
)

export default component.exports